import styled, { css, keyframes } from 'styled-components';

const wobble = keyframes`
  20% {
    transform: translateY(-40%);
  }

  40% {
    transform: translateY(0%);
  }

  60% {
    transform: translateY(-20%);
  }

  80% {
    transform: translateY(0%);
  }

  90% {
    transform: translateY(-10%);
  }
`;

export const StyledLoginModal = styled.div`
  background: rgba(251, 251, 251, 0.95);
  border-radius: 3px;
  border: 1px solid #ebebeb;
  bottom: 0;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
  left: 0;
  width: 100vw;
  opacity: ${props => (props.isVisible ? '1' : '0')};
  padding: 1em 1.25em;
  position: fixed;
  text-align: center;
  transform: translateY(0%);
  transition: visibility 0.3s ease, opacity 0.3s ease;
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  z-index: 1000;

  animation: ${props =>
    props.isWobble &&
    css`
      ${wobble} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both
    `};

  > p {
    margin: 0;

    > a {
      color: #0f4c81;

      &:hover {
        color: #177dd6;
      }
    }
  }
`;
